// extracted by mini-css-extract-plugin
export default {"btn":"QuotationPdf_btn__nwqS+","btnPrimary":"QuotationPdf_btnPrimary__g5iez"};